declare const window: any;

/**
 * Provide ability to interact with Adobe analytics. Requires that the page has been setup with Adobe analytics in sitecore otherwise this will not do anything.
 *
 * @returns
 */
export function useAnalytics() {
  /**
   * Send analytics data to Adobe. Eg. analytics.push('event1', { name: 'key1', value: 'value1', nested: { nestedname: 'nestedvalue1' } });
   *
   * @param eventName The name of the event that we want to push to adobe analytics.
   * @param properties JSON object containing additional properties we want to associate with this event.
   * @returns
   *
   */
  function push(eventName: string, properties: {}) {
    if (window.adobeDataLayer === undefined) {
      console.warn('Analytics unavailable. Please check page configuration then try again.');
      return;
    }

    // construct the payload
    const payload = {
      event: eventName,
      properties: properties,
    };

    try {
      window.adobeDataLayer.push(payload);
    } catch (error) {
      console.error(error);
      // output the error and continue
    }
  }

  return { push };
}
